import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types';
import { changePage } from '../../action/spa'

class MyReservations extends Component {
    goBack = () => {
        this.props.changePage("mainMenu");
    }
    render() {
        return (
            <div id="spa-reservation-list" class="movie-widgets">
                <div class="search-back" data-target="spa-main" onClick={this.goBack}>
                    <i class="fa fa-chevron-left"></i> Back</div>
                <h4>My reservations</h4>
                <div class="rs-orders-listing" style={{ background: "rgba(255,255,255,0.9)" }}>
                    <table class="w-100" cellpadding="10">
                        <thead>
                            <tr>
                                <th style={{ padding: "10px" }} class="w-45">Description</th>
                                <th class="w-25">Time | Date</th>
                                <th class="w-25">Location</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td style={{ padding: "10px" }}>Foot massage</td>
                                <td>
                                    Pool area
                            </td>
                                <td>
                                    16:00 | 10/15/19
                            </td>
                                <td>
                                    <a><i class="fa fa-close"></i></a>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        subTitle: state.store.spa.subTitle
    }
}

export default connect(
    mapStateToProps,
    {
        changePage

    }
)(MyReservations);
